import CollectionSorting from "./collection-sorting";
import Api from "./api";
import { arrayRemove } from "../utils";
import IListViewState from "../interface/list-view-state";
import IFieldWidth from "../interface/field-width";
import IFieldSorting from "../interface/field-sorting";
import IApiField from "../interface/api/api-field";
import SortingType from "../enum/sorting-type";

class CollectionStateInstance {

    public validateFields(entityId: number, fields: number[]): number[] {
        const result: number[] = [];
        fields.forEach((fieldId: number) => {
            const field: IApiField | null = Api.getField(fieldId);
            if (field && field.eCN === entityId) {
                result.push(fieldId);
            }
        });
        return result;
    }

    public toggleFieldSort(entityId: number, state: IListViewState, fieldId: number): IListViewState {
        const field: IApiField | null = Api.getField(fieldId);
        if (field && field.eCN === entityId) {
            const rule: IFieldSorting | null = state.sorting.find((s: IFieldSorting) => {
                return s.fieldId === fieldId
            }) || null;
            if (rule) {
                const type: SortingType | null = CollectionSorting.getNextType(rule.type);
                if (type === null) {
                    arrayRemove(state.sorting, rule);
                } else {
                    state.sorting[state.sorting.indexOf(rule)].type = type;
                }
            } else {
                state.sorting.push({
                    fieldId,
                    type: SortingType.Ascending,
                    order: state.sorting.length + 1
                });
            }
        }
        return state;
    }

    public setFieldWidth(entityId: number, state: IListViewState, fieldId: number, width: number): IListViewState {
        const field: IApiField | null = Api.getField(fieldId);
        if (field && field.eCN === entityId) {
            const cfg: IFieldWidth | null = state.fieldsWidths.find((w: IFieldWidth) => {
                return w.id === fieldId
            }) || null;
            if (cfg) {
                cfg.width = width;
            } else {
                state.fieldsWidths.push({
                    id: fieldId,
                    width
                });
            }
        }
        return state;
    }

    public toggleFieldHidden(entityId: number, state: IListViewState, fieldId: number): IListViewState {
        const field: IApiField | null = Api.getField(fieldId);
        if (field && field.eCN === entityId) {
            if (state.fieldsHidden.includes(fieldId)) {
                arrayRemove(state.fieldsHidden, fieldId);
            } else {
                state.fieldsHidden.push(fieldId);
            }
        }
        return state;
    }

    public toggleFieldReadonly(entityId: number, state: IListViewState, fieldId: number): IListViewState {
        const field: IApiField | null = Api.getField(fieldId);
        if (field && field.eCN === entityId) {
            if (state.fieldsReadonly.includes(fieldId)) {
                arrayRemove(state.fieldsReadonly, fieldId);
            } else {
                state.fieldsReadonly.push(fieldId);
            }
        }
        return state;
    }

}

const CollectionState = new CollectionStateInstance();

export default CollectionState;